var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCreditcardDesktop = function SvgCreditcardDesktop(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-6705 9060.545 29.603 20.784",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .creditcard-desktop-cls-1, .creditcard-desktop-cls-4 {\n        fill: none;\n      }\n\n      .creditcard-desktop-cls-1, .creditcard-desktop-cls-2 {\n\n      }\n\n      .creditcard-desktop-cls-2 {\n        fill: rgba(0,0,0,0);\n        stroke-width: 3px;\n      }\n\n      .creditcard-desktop-cls-3 {\n        stroke: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12915",
    "data-name": "Group 12915",
    transform: "translate(-6977 8507.567)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2318",
    "data-name": "Group 2318",
    transform: "translate(272 552.977)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2948",
    "data-name": "Rectangle 2948",
    className: "creditcard-desktop-cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "creditcard-desktop-cls-3",
    width: 29.602,
    height: 20.784,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "creditcard-desktop-cls-4",
    x: 0.5,
    y: 0.5,
    width: 28.602,
    height: 19.784,
    rx: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8366",
    "data-name": "Path 8366",
    className: "creditcard-desktop-cls-2",
    d: "M0,0H28.986",
    transform: "translate(0.308 5.983)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCreditcardDesktop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/creditcardDesktop.d3901289.svg";
export { ForwardRef as ReactComponent };